 import React, { useEffect, useRef, useState } from "react";
 import RegisterModal from "./components/RegisterModal";
 import useGlobalClickHandler from "./components/useGlobalClickHandler";
 
 import gsap from "gsap";
 import { ScrollTrigger } from "gsap/ScrollTrigger";
 import { pdfjs } from "react-pdf";
 import loader from "../src/assets/images/loading-icon.gif"
 

 import Routers from './routers';
import './App.css'
import './assets/css/jost.css'
import './assets/css/metform-ui.css'
import './assets/css/widget-image.min.css' 
import './assets/css/widget-rating.min.css'
import './assets/css/root-inline.css'
import './assets/css/reset.css'
import './assets/css/responsive.css'
import './assets/css/swiper.min.css'
import './assets/css/theme.css'
import './assets/css/v4-shims.min.css'
import './assets/css/widget-divider.min.css'
import './assets/css/widget-google_maps.min.css'
import './assets/css/widget-heading.min.css'
import './assets/css/widget-social-icons.min.css'
import './assets/css/widget-styles.css'
import './assets/css/widget-testimonial.min.css'
import './assets/css/all.min.css'
import './assets/css/cormorantgaramond.css'
import './assets/css/custom-frontend.min.css'
import './assets/css/custom-widget-icon-box.min.css'
import './assets/css/custom-widget-icon-list.min.css'
import './assets/css/ekiticons.css'
import './assets/css/e-swiper.min.css'
import './assets/css/fadeIn.min.css'
import './assets/css/fadeInDown.min.css'
import './assets/css/post-5.css'
import './assets/css/post-17.css'
import './assets/css/post-24.css'
import './assets/css/post-199.css'
import './assets/css/post-220.css'
import './assets/css/post-912.css'
import "./assets/css/pdfmodal.css";

import "react-medium-image-zoom/dist/styles.css";


import 'lenis/dist/lenis.css'
import 'swiper/css';
import 'swiper/css/navigation'; 
import "swiper/css/autoplay"; 
import ScrollTopButton from './animation/scrollTop';
import CursorGSAP from './animation/curserAnimation';

 pdfjs.GlobalWorkerOptions.workerSrc = new URL(
   "pdfjs-dist/build/pdf.worker.min.mjs",
   import.meta.url
 ).toString();
 
gsap.registerPlugin(ScrollTrigger);

function App() {
    useGlobalClickHandler();
   

   const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);



  return (
    <>
    {loading ? (
        <div className="loader-container">
          <img src={loader} alt="Loading..." />
        </div>
      ) : (
       <div className="App">
          <CursorGSAP/>
          <Routers/>
          <ScrollTopButton/>
          <RegisterModal />
        </div>
      )}
    </>
    
  );
}

export default App;
